import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';

/**
 * Returns new array with given chip toggled
 */
var toggleChip = function toggleChip(active, value, multiSelect) {
  return active.includes(value) ? active.filter(function (id) {
    return id !== value;
  }) : multiSelect ? [].concat(_toConsumableArray(active), [value]) : [value];
};

export { toggleChip };
